/**
 * Styles taken from packages/design-system/checkbox/src/internal/theme.tsx
 * To be used until mobile editor does not require legacy themed() API anymore
 */
var checkboxTheme = {
  light: {
    borderColor: {
      rest: "var(--ds-border-input, #8590A2)",
      hovered: "var(--ds-border-input, #8590A2)",
      disabled: "var(--ds-background-disabled, #091E4208)",
      checked: "var(--ds-background-selected-bold, #0C66E4)",
      active: "var(--ds-border, #091E4224)",
      focused: "var(--ds-border-focused, #388BFF)",
      hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #0055CC)"
    },
    boxColor: {
      rest: "var(--ds-background-input, #FFFFFF)",
      hovered: "var(--ds-background-input-hovered, #F7F8F9)",
      disabled: "var(--ds-background-disabled, #091E4208)",
      active: "var(--ds-background-input-pressed, #FFFFFF)",
      hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #0055CC)",
      checked: "var(--ds-background-selected-bold, #0C66E4)"
    },
    tickColor: {
      disabledAndChecked: "var(--ds-icon-disabled, #091E424F)",
      activeAndChecked: "var(--ds-icon-inverse, #FFFFFF)",
      checked: "var(--ds-icon-inverse, #FFFFFF)"
    }
  },
  /**
   * Fallback colours for dark mode taken from
   * packages/design-system/tokens/src/artifacts/themes/atlassian-dark.tsx
   * To be used to keep mobile / web checkbox dark mode consistent
   * until mobile editor does not require legacy themed() API anymore
   */
  dark: {
    borderColor: {
      rest: "var(--ds-border-input, #8590A2)",
      hovered: "var(--ds-border-input, #8590A2)",
      disabled: "var(--ds-background-disabled, #BCD6F00A)",
      checked: "var(--ds-background-selected-bold, #579DFF)",
      active: "var(--ds-border, #A6C5E229)",
      focused: "var(--ds-border-focused, #85B8FF)",
      hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #85B8FF)"
    },
    boxColor: {
      rest: "var(--ds-background-input, #22272B)",
      hovered: "var(--ds-background-input-hovered, #282E33)",
      disabled: "var(--ds-background-disabled, #BCD6F00A)",
      active: "var(--ds-background-input-pressed, #22272B)",
      hoveredAndChecked: "var(--ds-background-selected-bold-hovered, #85B8FF)",
      checked: "var(--ds-background-selected-bold, #579DFF)"
    },
    tickColor: {
      disabledAndChecked: "var(--ds-icon-disabled, #BFDBF847)",
      activeAndChecked: "var(--ds-icon-inverse, #1D2125)",
      checked: "var(--ds-icon-inverse, #1D2125)"
    }
  }
};
export default checkboxTheme;